// components/CityPickerButton.jsx
import React, { useState, useCallback, useEffect } from "react";
import CaretDownIcon from "../../icons/CaretDownIcon";
import GlobeIcon from "../../icons/GlobeIcon";
import { useRegion } from "../../context/RegionProvider";
import { CITY_CONSTANTS, reverseMapping } from "../../constants";

const adaptCityName = (cityName) => {
  return cityName
    ? cityName === "LOS_ANGELES"
      ? "Los Angeles"
      : cityName === "SAN_DIEGO"
      ? "San Diego"
      : cityName === "NEW_YORK"
      ? "New York"
      : cityName === "MIAMI"
      ? "Miami"
      : "All"
    : "All";
};

export function CityPickerButton({ className, /*city, */ onCityChange }) {
  const { city, region, openModal } = useRegion();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleCityChange = useCallback(
    (newCity) => {
      onCityChange(newCity);
      setIsOpen(false);
    },
    [onCityChange]
  );

  useEffect(() => {
    onCityChange(city);
  }, [city]);

  return (
    <>
      <button
        className={`tbk-mx-auto tbk-flex tbk-max-w-full tbk-items-center tbk-rounded-xl tbk-border tbk-border-solid tbk-border-grey-inactive ${
          city ? "tbk-py-0.5" : "tbk-py-1"
        } tbk-shadow-e tbk-px-1 lg:tbk-max-w-xs${
          className ? ` ${className}` : ""
        }`}
        // onClick={handleOpen}
        onClick={openModal}
      >
        <GlobeIcon
          className="tbk-mr-1 tbk-shrink-0 tbk-text-blue-grey"
          width={16}
          height={16}
        />
        {/*<div className="tbk-text-main small tbk-mr-1 tbk-whitespace-nowrap tbk-text-primary">*/}
        {/*  Location:*/}
        {/*</div>*/}
        <div
          className={`location-link tbk-text-main small tbk-block tbk-overflow-hidden tbk-text-ellipsis tbk-whitespace-nowrap ${
            city ? "tbk-text-primary" : "tbk-text-grey"
          }`}
        >
          {reverseMapping[city] || city}, {region}
        </div>

        <CaretDownIcon className="tbk-ml-1 tbk-shrink-0 tbk-text-blue-grey" />
      </button>

      {/*<CityPickerLS*/}
      {/*  isOpen={isOpen}*/}
      {/*  city={city}*/}
      {/*  onClose={handleClose}*/}
      {/*  onCityChange={handleCityChange}*/}
      {/*/>*/}
    </>
  );
}

export default CityPickerButton;
